export default "__VITE_ASSET__OHVHfI6p__"